/* eslint-disable no-fallthrough */

import Action  from './action.js'

import request from '../../../../api/api.js'











async function getEmployeeProfile(state = initailState){
    try {
        request({url: "/employee/profile",method: "POST"})
        
    } catch (error) {
        
    }
} 


const initialTab = {
    menu: '1',
    submenu: '1'
}

export const initailState = {

    activeTab:initialTab,
    initialTab,
    toastdata:{
        id:"",
        message:"",
        type:""
    },



    // agency details 

    company_name:'',
    jobtypelist:[],
    worklist:[],







    userid:"",
    

    // form details 

    // personal details 1

    title:"",
    firstname:"",
    middlename:"",
    lastname:"",
    maidenName:"",
    isNameChanged:"",
    previousName:"",
    gender:"",
    joining_date:"",
    empBio:"",
    UploadIDPhoto:"",


    // personal details 1
    dateofbirth:"",
    martialStatus:"",
    insuranceno:"",
    nationality:"",
    religion:"",


    // contact and address

    "mobileno": {
        "number": "",
        "code": "",
        "dialcountry": ""
    },
    email:"",
    homephone:"",
    streetAddress:"",
    addressline2:"",
    city:"",
    state:"",
    zip:"",
    country:"",
    dateMovedAddress:"",


    // Work & Personal Details

    locations: [],
    locationsValue:[],
    workstatus:"",
    job_type:[],
    job_typeValue:[],


    // General Availability

    work_mornings:false, 
    work_evenings:false,
    work_afternoons:false,
    work_occasional:false,
    work_parttime:false,
    work_fulltime:false,
    work_nights:false,
    work_weekends:false,
    work_anytime:false,
    availablestartdate:"",
    shortnotice:"",
    reduceworkflexibility:"",
    workstate:"",


    // ID & Right to Work

    // docType_info for id doc
    docType:"",
    docType_info: {
        doc_type: "",
        doc_url: [],
        doc_no: "",
        country_issue: "",
        expiry_date: "",
        country_issue_arr: [],
        isvisible:true
    },


    // Right to work 
    rightToWorkType:"",
    rightToWorkType_info:{
        doc_type: "",
        doc_url: [],
        doc_no: "",
        country_issue: "",
        expiry_date: "",
        country_issue_arr: [],
        isvisible:true
    },
    


    // Driving License Details
    drivinglicenceisVisible:true,
    drivinglicence:"",
    drivinglicenceno:"",
    drivingCountryOfIssue:"",
    licenceExpiry:"",
    licenceClass:"",
    caraccess:"",
    bannedfromdriving:"",
    uploaddriving:[],


    // LanguageDetails 

    englishspoken:"",
    englishwritten:"",
    otherlanguage:"",
    IELTStest:"",

    // DBS DETAILS

    currentDBS:"",
    dbsCertificateNo:"",
    dbsIssueDate:"",
    dbsExpirydate:"",
    dbsisVisible:true,
    uploaddbs:[],


    // NEXT OF KIN/EMERGENCY CONTACT

    kinfirstname:"",
    kinlastname:"",
    kinrelationship:"",
    kinhomephone:"",
    kinmobileno:{
        number:"",
        code:"",
        dailcountry:""
    },
    kinemail:"",
    
    // Address for kin/EC
    save_as_my_current:false,
    kinstreetAddress:"",
    kinaddressline2:"",
    kincity:"",
    kinstate:"",
    kinzip:"",
    kincountry:"",


    // Employment & Education

    // Qualifications doc

    education_qualification:[],
    /*
    education_qualification Array of
    {
        "_id": "",
        "qualification_course": "",
        "qualification_level": "",
        "qualification_title": "",
        "qualification_date": "",
        "fileName": "",
        "filePath": "",
        "qualification_date_expiry": ""
    }
    */


    training_other_courses:[],
    /*
    training_other_courses Array of
    {
        "_id":"",
        "other_qualification_course": "",
        "other_qualification_level": "",
        "other_qualification_title": "",
        "other_qualification_date": "",
        "other_qualification_date_expiry": "",
        "fileName": "",
        "filePath": ""	
    }
    */


    professional_Body:[],
    /*
    professional_Body Array of
    {
        "_id": "",
        "professionalBody": "",
        "pinRef": "",
        "professionalBodyExpiry": "",
        "fileName": "",
        "filePath": ""
    }
    */
    



    // Skills & Work History

    work_experience:[],
    /*
        work_exp ARRAY OF 
    {
        "_id": "",
        "work_title": "",
        "employer": "",
        "work_from_date": "",
        "work_to_date": ""
    }
    */

    skillProvideDetails:"",

    skills:[],
    /*
    skills array of
    {
        "_id":',
        "skills_title": ""
    }
    */

    languages:[],
    /*
        languages array of 
    {
        _id:"",
        languages_title:""
    }
     */



    // WORKING TIME REGULATIONS *  tab sub menu 
    workTimeDate:"",
    workTimeSignature:"",

    // HEALTH DECLARATION
    acceptHealthDeclaration:"",
    HealthDeclarationDate:"",

    // PERSONAL DECLARATION
    acceptPersonalDeclaration:"",
    PersonalDeclarationDate:"",

    // CONFIDENTIALITY
    ConfidentialityDate:"",
    acceptConfidentiality:"",

    // REHABILITATION OF OFFENDERS ACT 1974 & CRIMINAL RECORDS
    criminaloffence:"",
    criminalCautioned:"",
    criminalConvictions:"",
    criminalCourt:"",
    criminalDisciplinaryAction:"",
    criminalAdditionalInformation:"",

    // "Disclosure Barring Service (DBS)
    dbsAccept:"",
    dbsAcceptDate:"",

    // DISABILITY & DISCRIMINATION ACT 1985
    registereddisabled:"",
    // if registereddisabled equals yes
    disableRegisteredDetails:"",

    disableAct:"",
    // if disableAct equals yes
    disableActDetails:"",

    disableOverCome:"",
    // if disableOverCome equal yes
    disableOverComeDetails:"",


    // APPLICATION FORM DECLARATION
    declarationAccept:"",
    declarationAcceptDate:"",
    signature:"",




    // OTHER DOCUMENTS
    other_documents:[],
    // other_documet Array of 
    /*
    {
    "document_title": "OD doc ",
    "document_expiry": true,
    "document_expiry_date": "2023-12-15T00:00:00.000Z",
    "upload_doc": "uploads/images/employee/1695619670964.png"
    }
    */



    // REFERENCES
    // Reference 1
    "firstref_address": {
        "firstrefstreetAddress": "",
        "firstrefcity": "",
        "firstrefstate": "",
        "firstrefzip": ""
    },
    "firstrefconfirmemail": "",
    "firstrefemail": "",
    "firstreffirstname": "",
    "firstreflastname": "",
    "firstrefphone": {
        "number": "",
        "code": "44",
        "dialcountry": "gb"
    },
    "firstrefrelationship": "",
    "firstrefisvisible":true,

    // Reference 2
    "secondref_address": {
        "secondrefstreetAddress": "",
        "secondrefcity": "",
        "secondrefstate": "",
        "secondrefzip": ""
    },
    "secondrefconfirmemail": "",
    "secondrefemail": "",
    "secondreffirstname": "",
    "secondreflastname": "",
    "secondrefphone": {
        "number": "",
        "code": "44",
        "dialcountry": "gb"
    },
    "secondrefrelationship": "",
    "secondrefisvisible":true,

    // Reference 3
    "thirdref_address": {
        "thirdrefstreetAddress": "",
        "thirdrefcity": "",
        "thirdrefstate": "",
        "thirdrefzip": ""
    },
    "thirdrefconfirmemail": "",
    "thirdrefemail": "",
    "thirdreffirstname": "",
    "thirdreflastname": "",
    "thirdrefphone": {
        "number": "",
        "code": "44",
        "dialcountry": "gb"
    },
    "thirdrefrelationship": "",
    "thirdrefisvisible":true,



    // Health Questionnaire

    sufferedlongtermillness:"",
    //  if yes sufferedlongtermillness
    sufferedlongtermillness_notes:"",

    leaveforneckinjury:"",
    // if yes leaveforneckinjury
    leaveforneckinjury_notes:"",

    neckinjuries:"",
    // if yes neckinjuries
    neckinjuries_notes:"",
    
    sixweeksillness:"",
    // if yes sixweeksillness
    sixweeksillness_notes:"",
    
    communicabledisease:"",
    // if yes communicabledisease
    communicabledisease_notes:"",

    medicalattention:"",
    // if yes medicalattention
    healthdeclarationdetails:"",

    absentfromwork:"",


    // Medical History 2
    
    medicalillness:"",
    // if yes medicalillness
    medicalillness_notes:"",
    
    medicalillnesscaused:"",
    // if yes medicalillnesscaused
    medicalillnesscaused_notes:"",
    
    treatment:"",
    // if yes treatment
    treatment_notes:"",
    
    needanyadjustments:"",
    // if yes needanyadjustments
    needanyadjustmentsnotes:"",


    // TUBERCULOSIS
        
    livedUK:"",
    // if no livedUK
    livedUKnotes:"",
        
    BCGvaccination:"",
    cough:"",
    weightloss:"",
    fever:"",
    TB:"",




    // MEDICAL HISTORY ---> yes or no questions
    heartCirculatory:"",
    diabetes:"",
    asthma:"",
    bronchitis:"",
    epilepsy:"",
    headaches:"",
    psychiatric:"",
    dermatitis:"",
    backProblems:"",
    recurrentInfections:"",
    hepatitis:"",
    chickenpox:"",

    // COVID vaccination History
    covidVaccination:'',
    covidVaccination_date:"",


    // Immunisation History
    varicella:"",
    tuberculosis:"",
    heaf:"",
    rubella:"",
    poliomyelitis:"",
    hepatitisB:"",
    tetanus:"",
    typhoid:"",


    // GP’s Details
    GPname:"",
    GPphone:{
        dialcountry:"",
        number:"",
        code:""
    },
    GPstreetAddress:"",
    GPcity:"",
    GPstate:"",
    GPzip:"",


    // Payment Details
    bankName:"",
    accountType:"",
    accountName:"",
    bank_sort_code:"",
    bank_ac_name:"",
    
    addtionalFieldsValue:[],




    //  addtional Fields forn the form ...
    addtionalFields:[],
    staticFields:[],



    // Image viewer data
    viewUrl:"",
    isPreview:false,




    











    
    // to update form
    updateForm : (data)=>{
        return new Promise(async (reslove , reject)=>{
            try {
              let res = await request({ url:"/employees/apply-online-form/v2" , method:"post" , data });
                  if(res && res.status === 1){
                    // this.toastdata = { id:'formupdate',message:res.response , type:"success"}
                    return reslove(res)
                  }
                    // this.toastdata  = { id:'formupdate',message:res.response , type:"error"} 
                    reject(res)
            } catch (error) {
                // this.toastdata = { id:'formupdate',message:error && error.response , type:"error"} 
                reject(error)
            }
        })
    }


}




// dispatch action


const toggleTab = ( state = initailState , tab = '', tabId = '') =>{
    return {
        ...state,
        activeTab:{
            ...state.activeTab,
            [tab]:tabId
        }
    }
}










/**
 * @typedef {Object} PayloadType
 * @property {string} tab
 * @property {string} tabId
 * @property {string} tab
 */


/**
 * @typedef {Object} ActionType
 * @property {import("./action").ActionName} type
 * @property {PayloadType} payload
 */

//  profile reducer 
/**
 * Profiler Reducer
 * @param {ActionType} action - The {@link Action } for reducer
 */

export default function profilereducer(state = initailState , action) {
    let payload = action.payload || {};

    switch (action.type){

        case Action.TOGGLETAB :{
            return toggleTab(state ,payload.tab , payload.tabId )
        }

        case Action.SETSTATE:{
            return {...state , ...payload}
        }

        case Action.GETPROFILE:{
            return getEmployeeProfile(state)
        }



        case Action.SETTOST:{
            return {...state ,toastdata:payload  }
        }

        case Action.TOGGLE_IMAGE_VIEWER:{
            return {...state ,viewUrl:payload.viewUrl ,isPreview:!state.isPreview}
        }








        case Action.UPDAEFORM:{
            return new Promise(async (reslove , reject)=>{
                    try {
                      let res = await request({ url:"/employees/apply-online-form/v2" , method:"post" , payload });
                          if(res && res.status === 1){
                            reslove(res);
                            return {...state ,toastdata:{ id:'formupdate',message:res.response , type:"success"} }
                          }
                            reject(res)
                            return {...state ,toastdata:{ id:'formupdate',message:res.response , type:"error"} }
                    } catch (error) {
                        reject(error)
                        return {...state ,toastdata:{ id:'formupdate',message:error && error.response , type:"error"} }
                    }
                })
            }

        default: 
            return state;
    }
}


